/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore'
], (_) => {


	class WidgetUpgradeUtils {

		findProperty(id, properties) {
			return _.find(properties, function (property) {
				return property.id === id;
			});
		}

		findLayout(layouts = [], widgetId){
			let match = null;
			for (let i = 0; i < layouts.length; i++){
				if (layouts[i].id === widgetId){
					match = layouts[i];
				}
				if (!match && layouts[i].items){
					match = this.findLayout(layouts[i].items, widgetId);
				}
				if(match){
					break;
				}
			}
			return match;
		}

		specHasWidgets(spec) {
			return spec && spec.widgets && !_.isEmpty(spec.widgets);
		}

		isLiveWidgetModel(model) {
			return model && model.type && model.type === 'live';
		}

		setDefaultProperty(model, propertyName, defaultValue) {
			const oldProp = this.findProperty(propertyName, model.properties);
			if (!oldProp) {
				if (!model.properties) {
					model.properties = [];
				}
				model.properties.push({
					id: propertyName,
					value: defaultValue
				});
			}
		}
	}

	return new WidgetUpgradeUtils();
});
